import { useEffect, useState } from "react";
import { Box, Button, Input, Typography } from "@mui/material";
import PageHeading from "../../layout/PageHeading";
import { useTheme } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeProduct, updateCartItemCount } from "../../redux/actions/cartActions";

export default function CartPage() {
  const allProduct = useSelector((state) => state.counter);
  const theme = useTheme();
  const [cartData, setCartData] = useState(allProduct?.products);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleIncrease = (item) => {
    const updatedCart = cartData.map((cartItem) =>
      cartItem.product[0].unqid === item.product[0].unqid
        ? { ...cartItem, count: cartItem.count + 1 }
        : cartItem
    );
    setCartData(updatedCart);
    localStorage.setItem("cartData", JSON.stringify(updatedCart));

    dispatch(updateCartItemCount(item.product[0].unqid, 'inc'));
  };

  useEffect(() => {
    if (!cartData || cartData.length === 0) {
      navigate("/shop");
    }
  }, [cartData, navigate]);

  const handleDecrease = (item) => {
    const updatedCart = cartData.map((cartItem) =>
      cartItem.product[0].unqid === item.product[0].unqid
        ? { ...cartItem, count: Math.max(cartItem.count - 1, 1) }
        : cartItem
    );
    setCartData(updatedCart);
    localStorage.setItem("cartData", JSON.stringify(updatedCart));

    dispatch(updateCartItemCount(item.product[0].unqid, 'dec'));
  };


  // useEffect(() => {

  //   const getData = JSON.parse(localStorage.getItem("cartData"));
  //   setCartData(getData);
  // }, [])

  const removeFromCart = (item) => {
    const removeData = cartData.filter((val) => val.product[0].unqid !== item.product[0].unqid);
    localStorage.setItem('cartData', JSON.stringify(removeData));
    const unqid = item.product[0].unqid;
    setCartData(removeData);
    dispatch(removeProduct(unqid));
  }

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    cartData?.forEach(item => {
      totalPrice += item.product[0]?.ProductPrice * item.count;
    });
    return totalPrice;
  };
  let GST = (calculateTotalPrice() * 5) / 100;

  const proceedToCheckOut = () => {
    const totalPrice = calculateTotalPrice() + GST;
    localStorage.setItem('totalPrice', JSON.stringify(totalPrice));
    navigate("/checkout");
  }

  return (
    <>
      <PageHeading title="Cart" />
      <div className="cart-container">
        {cartData.length === 0 ? (
          <Box sx={{ textAlign: "center", mt: 5 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                fontFamily: theme.palette.typography.fontFamily1,
                mb: 2,
              }}
            >
              🛒 Your cart is empty!
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/shop')}
              sx={{
                bgcolor: "#8B7355",
                fontSize: "16px",
                "&:hover": { bgcolor: "#6F5B3E" },
              }}
            >
              Back to Shop
            </Button>
          </Box>
        ) : (
          <>
            <Box sx={{ overflowX: 'auto' }}>
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>
                      <Typography
                        sx={{
                          fontFamily: theme.palette.typography.fontFamily1,
                          fontWeight: 500,
                          fontSize: '18px'
                        }}>
                        Image
                      </Typography>
                    </th>
                    <th>
                      <Typography
                        sx={{
                          fontFamily: theme.palette.typography.fontFamily1,
                          fontWeight: 500,
                          fontSize: '18px'
                        }}>
                        ClothType
                      </Typography>
                    </th>
                    <th>
                      <Typography
                        sx={{
                          fontFamily: theme.palette.typography.fontFamily1,
                          fontWeight: 500,
                          fontSize: '18px'
                        }}>
                        Price
                      </Typography>
                    </th>
                    <th>
                      <Typography
                        sx={{
                          fontFamily: theme.palette.typography.fontFamily1,
                          fontWeight: 500,
                          fontSize: '18px'
                        }}>
                        Quantity
                      </Typography>
                    </th>
                    <th>
                      <Typography
                        sx={{
                          fontFamily: theme.palette.typography.fontFamily1,
                          fontWeight: 500,
                          fontSize: '18px'
                        }}>
                        Subtotal
                      </Typography>
                    </th>
                    <th>
                      <Typography
                        sx={{
                          fontFamily: theme.palette.typography.fontFamily1,
                          fontWeight: 500,
                          fontSize: '18px'
                        }}>
                        Remove
                      </Typography>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    cartData?.map((val, i) => (
                      <tr>
                        <td>
                          <Box>
                            <img src={val.product[0]?.ProductImage} alt="Product" style={{ objectFit: 'cover' }} />
                            {/* <img src={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + val.product[0]?.ProductImage} alt="Product" style={{ objectFit: 'cover' }} /> */}
                          </Box>
                        </td>
                        <td>
                          <Typography
                            sx={{
                              fontFamily: theme.palette.typography.fontFamily1,
                              fontWeight: 500,
                            }}>
                            {val.product[0]?.ClothesType}
                          </Typography>
                        </td>
                        <td>
                          <Typography
                            sx={{
                              fontFamily: theme.palette.typography.fontFamily1,
                              fontWeight: 500,
                            }}>
                            ₹ {val.product[0]?.ProductPrice.toFixed(2)}
                          </Typography>
                        </td>
                        <td>
                          <button
                            className="quantity-button"
                            onClick={() => handleDecrease(val)}
                            disabled={val.count === 1}
                          >
                            -
                          </button>
                          <input
                            type="text"
                            value={val.count}
                            className="quantity-input"
                            readOnly
                          />
                          <button className="quantity-button" onClick={() => handleIncrease(val)}>+</button>
                        </td>
                        <td>
                          <Typography
                            sx={{
                              fontFamily: theme.palette.typography.fontFamily1,
                              fontWeight: 500,
                            }}>₹ {val.product[0]?.ProductPrice.toFixed(2) * val.count}
                          </Typography>
                        </td>
                        <td>
                          <Button
                            onClick={() => removeFromCart(val)}
                            variant="contained"
                            sx={{
                              py: 1,
                              px: 2,
                              bgcolor: "red",
                            }}
                          >
                            Remove
                          </Button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </Box>

            <div className="cart-total">
              <Typography variant='h4' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                Cart Totals
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                  Sub Total
                </Typography>
                <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                  ₹ {calculateTotalPrice()}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                  GST (5%)
                </Typography>
                <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                  ₹ {GST}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                  Total
                </Typography>
                <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                  ₹ {calculateTotalPrice() + GST}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "14px" },
                  color: "gray",
                  mt: 1,
                  fontFamily: theme.palette.typography.fontFamily1,
                  fontWeight: 500,
                }}
              >
                Enjoy easy delivery! 🚚 ₹150 for Cash on Delivery. Online payment: ₹30 within Gujarat, ₹80 outside Gujarat. Charges may vary based on your city and state.
              </Typography>

              <Button
                onClick={() => proceedToCheckOut()}
                variant="contained"
                sx={{
                  py: 1,
                  bgcolor: "#8B7355",
                  mt: 2,
                  width: "100%",
                  fontSize: "18px",
                  "&:hover": { bgcolor: "#6F5B3E" },
                }}
              >
                Proceed to Checkout
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
